// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__254oE","inputDescription":"styles_inputDescription__3fcfy"};